import { ShopVO } from './types';
import { AxiosPromise } from 'axios';
import request from '../network';

//获取部门列表
export function getShopListApi(): AxiosPromise<ShopVO[]> {
  return request({
    url: `/system/shop/list`,
    method: 'GET',
    data: {},
  });
}

export const switchShopApi = () => {
  return request({
    url: '/system/shop/switchShop',
    method: 'GET',
  });
};

export const enterShopApi = (data: { shopId: number; autoSelectNextTime?: number; nextAutoEnterShopId?: number }) => {
  return request({
    url: '/system/shop/enterShop',
    method: 'POST',
    data,
  });
};

export const getDefaultShopApi = () => {
  return request({
    url: '/system/shop/getDefaultShop',
    method: 'GET',
  });
};

export default {};
